// src/utils/notification.js
// Simple utility to show toast notifications to users

/**
 * Show a toast notification message
 * 
 * @param {string} message - The message to display
 * @param {string} type - Type of notification: 'success', 'error', 'info'
 * @param {number} duration - How long to show the message (milliseconds)
 */
export const showNotification = (message, type = 'success', duration = 3000) => {
  // Create the notification element
  const notification = document.createElement('div');
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 15px 25px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 2000;
    font-weight: 600;
    color: white;
    transition: opacity 0.3s, visibility 0.3s;
    ${type === 'error' ? 'background-color: #DC2626;' : 'background-color: #1E3A8A;'}
  `;

  // Add to the page
  document.body.appendChild(notification);

  // Remove after duration
  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.visibility = 'hidden';
    setTimeout(() => document.body.removeChild(notification), 300);
  }, duration);
};
/**
 * Alert-style notification (warning / attention)
 *
 * @param {string} message
 * @param {number} duration
 */
export const alertNotification = (message, type = 'success', duration = 4000) => {
  const notification = document.createElement('div');
  notification.textContent = message;

  notification.style.cssText = `
    position: fixed;
    top: 200px;
    right: 20px;
    padding: 16px 28px;
    border-radius: 10px;
    
    color: #1F2937;
    font-weight: 700;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    z-index: 3000;
    border-left: 6px solid #92400E;
    animation: alertSlideIn 0.35s ease-out;
    ${type === 'error' ? 'background-color: #DC2626;' : 'background-color: #1E3A8A;'}
    
  `;

  // Inject animation once
  if (!document.getElementById('alert-notification-style')) {
    const style = document.createElement('style');
    style.id = 'alert-notification-style';
    style.innerHTML = `
      @keyframes alertSlideIn {
        from {
          opacity: 0;
          transform: translateX(40px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
    `;
    document.head.appendChild(style);
  }

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transform = 'translateX(40px)';
    setTimeout(() => document.body.removeChild(notification), 300);
  }, duration);
};